import React, { useEffect, useState } from 'react'
import CustomerContainer from '../../components/customers/CustomersContainer'

const CustomerPage = () => {
  return (<CustomerContainer></CustomerContainer>)
}

export default CustomerPage